import { Pagination, List, Confirm, Datagrid } from 'react-admin'

import { PAGINATION_PER_PAGE, PAGINATION_PER_PAGE_CHOICES } from './pagination'

Pagination.defaultProps = {
  ...List.defaultProps,
  rowsPerPageOptions: PAGINATION_PER_PAGE_CHOICES,
}

List.defaultProps = {
  ...List.defaultProps,
  perPage: PAGINATION_PER_PAGE,
  exporter: false,
}

Confirm.defaultProps = {
  ...Confirm.defaultProps,
  CancelIcon: () => null,
  ConfirmIcon: () => null,
  confirmColor: 'warning',
}
